import JoditEditor from 'jodit-react';
import React, { useMemo } from 'react';

const EditorV2: React.FC<{ value: string; onChange: (_newContent: string) => void }> = ({ ...props }) => {
  const config = useMemo(
    () => ({
      readonly: false
    }),
    []
  );

  return (
    <JoditEditor
      {...props}
      config={config}
      tabIndex={1} // tabIndex of textarea
    />
  );
};

export default EditorV2;
